export default "__VITE_ASSET__Bh4qikO9__"